import React, { useState, useEffect, useCallback } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import axios from 'axios';
//import util from 'util';
import constClass from '../../Constants/Constants';
import moment from 'moment';
import DatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import ja from 'date-fns/locale/ja';
import BookingList from "./BookingList";

registerLocale('ja', ja);
const BookingListTab = (props) => {
  const [searchData, setSearchData] = useState({
    book_start: moment().subtract(1, 'month').startOf('month').format('YYYY/MM/DD'),
    book_end: moment().add(2, 'month').endOf('month').format('YYYY/MM/DD'),
    book_date: moment().format('YYYY/MM/DD'),
    category: '',
    shop_id: props.user.shopId ? props.user.shopId : '',
    status: [constClass.STATUS.TREG],
  })
  const statusIndex = (status) => {
    if ([constClass.STATUS.REG, constClass.STATUS.RDE].includes(status)) {
      return 1;
    } else if (status === constClass.STATUS.FIN) {
      return 2;
    } else if (status === constClass.STATUS.CCL) {
      return 3;
    } else {
      return 0;
    }
  };
  const [shoplist, setShoplist] = useState([]);
  const [selectDisabled, setSelectdisabled] = useState(true);
  const [calendarList, setCalendarList] = useState([]);
  const [categoryList, setCategoryMaster] = useState([]);

  const [index, setIndex] = useState(statusIndex(props.sts));
  const handleTabSelect = (idx, lastIndex, e) => {
    setIndex(idx);
    setSearchData({ ...searchData, status: idx === 0 ? [constClass.STATUS.TREG] : idx === 3 ? [constClass.STATUS.CCL] : idx === 2 ? [constClass.STATUS.FIN] : [constClass.STATUS.REG, constClass.STATUS.RDE] });
  }
  const refreshMaster = useCallback(async () => {
    //トークンを取得
    const jwt = localStorage.getItem('jwt');
    const shopPromise = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/shop/search`, { site_id: props.siteId, operator: "and", where: [{ site_id: props.siteId }] }, { headers: { Authorization: `Bearer ${jwt}` } });
    const shoplist = (await shopPromise).data
    setShoplist(shoplist);

    if (searchData.shop_id === '') {
      const shop = shoplist
        .map((item) => item.shop_id)
        .reduce((min, cur) => (String(cur) < String(min) ? cur : min));
      console.log(shop);
      var tmp = { ...searchData, shop_id: shop };
      await setSearchData(tmp);
    }

    const params = {
      site_id: props.siteId,
      book_start: searchData.book_start,
      book_end: searchData.book_end,
      shop_id: searchData.shop_id,
    }
    const calendarPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/calendar/listalldate/`, params, { headers: { Authorization: `Bearer ${jwt}` } });
    const categoryPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/category/listall`, { site_id: props.siteId }, { headers: { Authorization: `Bearer ${jwt}` } });
    const calendar = (await calendarPromise).data;
    const category = (await categoryPromise).data;
    setCalendarList(calendar);
    setCategoryMaster(category);
    //ユーザー権限確認
    if (props.user.userClass === '1') {
      await setSelectdisabled(false);
    }
  }, [props.siteId, searchData]);

  useEffect(() => {
    refreshMaster();
  }, [refreshMaster]);

  const handleCategory = (e) => {
    const target = e.target;
    var tmp = { ...searchData, category: target.value };
    setSearchData(tmp);
  }

  const changeSelectShop = (date => {
    //店舗選択
    const target = date.target;
    var tmp = { ...searchData, shop_id: target.value };
    setSearchData(tmp);
  })

  const renderHeader = () => {
    return (
      <div className="mx-0">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>利用日付</span>
          </div>
          <div className="col-2 text-center">
            <DatePicker className="custom-select w-100 text-center border-textbox text-primary"
              aria_labal="利用日付" locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id="book_date" name="book_date"
              popperPlacement='bottom'
              popperModifiers={{
                flip: {
                  behavior: ["bottom"] // don't allow it to flip to be above
                },
              }}
              selected={searchData.book_date ? new Date(searchData.book_date) : null}
              onChange={date => setSearchData({ ...searchData, book_date: date ? moment(date).format('YYYY/MM/DD') : null })}
              placeholderText="- 選択 -"
              disabledKeyboardNavigation
              includeDates={calendarList.reduce((list, item) => list.concat(new Date(item.book_date)), [])}
              highlightDates={calendarList.reduce((list, item) => list.concat(new Date(item.book_date)), [])}
              customInput={<button>{searchData.book_date ? searchData.book_date : "- 選択 -"}</button>}
            />
          </div>
          <div className="col-1 text-center align-self-center">
            <span>カテゴリ</span>
          </div>
          <div className="col-3 text-center">
            <select className="custom-select w-100" aria-label="カテゴリ" value={searchData.category || ''} onChange={handleCategory}>
              <option value="">選択してください</option>
              {categoryList.map((item) =>
                <option key={item.category_id} value={item.category_id}>{item.category_name}</option>
              )}
            </select>
          </div>
          <div className="col-1 text-center align-self-center">
            <span>支所</span>
          </div>
          <div className="col-3 text-center">
            <select className="custom-select text-center" aria-label="支所"
              value={searchData.shop_id}
              onChange={changeSelectShop}
              disabled={selectDisabled}
            >
              {shoplist.map((item, idx) =>
                <option key={idx} value={item.shop_id}>{item.shop_name}</option>
              )}
            </select>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="container">
      {(categoryList.length > 0) && renderHeader()}
      <Tabs onSelect={handleTabSelect}>
        <TabList className="nav nav-pills mb-2">
          <Tab className="nav-item"><button className={`nav-link ${index === 0 ? 'active' : ''}`} href="#">仮予約</button></Tab>
          <Tab className="nav-item"><button className={`nav-link ${index === 1 ? 'active' : ''}`}>予約承認済</button></Tab>
          <Tab className="nav-item"><button className={`nav-link ${index === 2 ? 'active' : ''}`} href="#">来店済</button></Tab>
          <Tab className="nav-item"><button className={`nav-link ${index === 3 ? 'active' : ''}`} href="#">キャンセル済</button></Tab>
        </TabList>
        <TabPanel>
          <BookingList {...props} {...{ condition: { searchData, categoryList } }} />
        </TabPanel>
        <TabPanel>
          <BookingList statusIdx={index} {...props} {...{ condition: { searchData, categoryList } }} />
        </TabPanel>
        <TabPanel>
          <BookingList statusIdx={index} {...props} {...{ condition: { searchData, categoryList } }} />
        </TabPanel>
        <TabPanel>
          <BookingList statusIdx={index} {...props} {...{ condition: { searchData, categoryList } }} />
        </TabPanel>
      </Tabs>
    </div>
  )
}

export default BookingListTab;